module.exports = __webpack_public_path__ + "img/43.0a2059fa.jpg";